<template>
  <div>
    <template v-if="showHeader && resourceCenter">
      <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
      <v-row class="mt-10">
        <v-col class="d-flex pt-0">
          <img
              alt="tcdc-resource-center"
            src="../../assets/icons/sorts/resource_center.png"
            class="tcdc-resource-center-layout-icon mr-4"
          />
          <span class="text-tcdc-green bold header text-uppercase">resource center</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <span class="text-tcdc-green header bold text-uppercase">
            {{resourceCenter[`title_${lang}`]}}
          </span>
        </v-col>
      </v-row>
    </template>
    <v-row class="my-8">
      <v-col v-if="resourceCenter && resourceCenter[`description_${lang}`]">
        <div class="bold header grey--text vhtml" v-html="resourceCenter[`description_${lang}`]">
        </div>
      </v-col>
    </v-row>
    <v-row class="mb-8">
      <v-col v-if="resourceCenter && resourceCenter.attached_website">
        <a @click="goToWebsite(resourceCenter.attached_website)">
          <GreenButton label="visit website" />
        </a>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="resourceCenter && resourceCenter.slide_images.length > 0">
        <ImageCarousel :images="resourceCenter.slide_images"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GreenButton from "../../components/buttons/GreenButton";
import ImageCarousel from "../../components/carousels/ImageCarousel";
import { mapState } from "vuex";
import {BreadcrumbUtil} from "@/util/BreadcrumbUtil";

export default {
  components: {
    GreenButton,
    ImageCarousel
  },
  props: {
    showHeader: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.items = BreadcrumbUtil.setServiceItem(
        this.items,
        this.branchId,
        this.branchName,
        this.allBranches,
        this.lang
    )
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
      lang: state => state.Branch.lang,
      resourceCenter: state => state.ServiceMenu.resource_centers.resource_center
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items = BreadcrumbUtil.setServiceItem(
          this.items,
          this.branchId,
          this.branchChanged,
          this.allBranches,
          this.lang
      )
    }
  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        to: "/home/:branch"
      },
      {
        text: "SERVICE",
        disabled: false,
        to: "/:branch/service"
      },
      {
        text: "RESOURCE CENTER",
        href: "/:branch/service/resource-center"
      },
      {
        text: "TCDC RESOURCE CENTER",
        disabled: true,
      }
    ]
  }),
  methods: {
    goToWebsite(url){
      if(url){
        window.open(url,'_blank')
      }
    }
  }
};
</script>

<style>
</style>
